import styled from "styled-components";

export const Header = styled.div`
  width: 100%;

  .first-line {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  .action {
    color: var(--text-secondary, rgba(66, 61, 60, 0.64));
    cursor: pointer;
  }

  .subheader {
    color: var(--text-secondary, rgba(66, 61, 60, 0.64));

    /* body */
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    letter-spacing: 0.16px;
  }
`;

export const RaffleLine = styled.div`
  display: flex;
  align-items: center;
  height: 52px;

  .index {
    display: flex;
    width: 28px;
    height: 28px;
    justify-content: center;
    align-items: center;
    gap: 8px;

    border-radius: 16px;
    background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  }

  .address {
    margin-left: 12px;
    width: 80px;
    max-width: 140px;
    flex-grow: 0;
  }

  .wide {
    flex-grow: 1;
  }

  .number {
    display: flex;

    img {
      margin: 0 8px;
      width: 24px;
    }
  }

  .win-amount {
    display: flex;
    height: 24px;
    min-width: 24px;
    padding: var(--spacing-space-4, 4px) var(--spacing-space-8, 8px);
    justify-content: center;
    align-items: center;
    gap: var(--spacing-space-4, 4px);

    border-radius: var(--rounding-radius-m, 16px);
    background: var(--fill-accent-secondary, rgba(50, 250, 220, 0.16));
    backdrop-filter: blur(12px);

    color: var(--text-primary, #000);

    /* label-s */
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 10px; /* 83.333% */
    letter-spacing: 0.5px;

    white-space: nowrap;
  }

  @media (min-width: 500px) {
    .address {
      width: auto;
      flex-grow: 2;
    }
  }
`;

export const RaffleWrapper = styled.div`
  // to not collapse skeleton margins
  display: grid;
`;

export const RaffleLineSkeleton = styled.div`
  overflow: hidden;
  margin: 14px 0;
  height: 24px;
  border-radius: var(--rounding-radius-s, 12px);
  background: var(--background-secondary, #f7f4f3);
`;
